import Loader from '@shared/components/Loader.tsx';

const FullScreenLoader = () => {
    return (
        <div className='d-flex h-screen align-items-center'>
            <Loader />
        </div>
    );
};

export default FullScreenLoader;
